import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useTranslation } from 'react-i18next';
import VisuallyHidden from 'components/VisuallyHidden';
import { ContentCardButton } from 'components/ContentCards';
export function ExternalLink(_ref) {
  var assetName = _ref.assetName,
    webUrl = _ref.webUrl,
    onWasClicked = _ref.onWasClicked;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  return /*#__PURE__*/React.createElement(ContentCardButton, {
    as: "a",
    href: "/api/url?url=".concat(encodeURIComponent(webUrl)),
    target: "_blank",
    rel: "noopener noreferrer",
    icon: "external",
    onClick: onWasClicked
  }, t('actions_open_link'), /*#__PURE__*/React.createElement(VisuallyHidden, null, " ", assetName));
}
export default ExternalLink;